import React from 'react';
import SearchBox from '../components/SearchBox';
import CardList from '../components/CardList';
import Scroll from '../components/Scroll';
import ErrorBoundary from '../components/ErrorBoundary';
//import {robots} from './robots';
//import { render } from '@testing-library/react';

//PROPS : proterties infromation from parent to child
//STATE: object that can describe the changes in the app
//CHILDREN

class App extends React.Component{
    constructor(){
        super();
        this.state={
            robots:[],
            searchfield:''
        }
    }

    componentDidMount(){
        fetch("https://jsonplaceholder.typicode.com/users")
        .then(response => response.json())
        .then(users =>this.setState({robots:users}));
    }
    onSearchChange=(event)=>{
        this.setState({searchfield:event.target.value})
        
    }

    render(){
        const{robots,searchfield}=this.state;
        const filteredRobots = robots.filter(robot =>{
            return robot.name.toLowerCase().includes(searchfield.toLowerCase());
        })
        return robots.length===0?
        <h1 className='tc'> Loading </h1>:
                (<div className='tc'>
                    <h1 className='f2'>RoboFriends</h1>
                    <SearchBox searchChange={this.onSearchChange}/>
                    <Scroll>
                        <ErrorBoundary>
                        <CardList robots={filteredRobots}/>
                        </ErrorBoundary>
                    </Scroll>
                </div>
        );
    }
} 

export default App;